export default __webpack_public_path__ + "static/media/logo-monibrand.3499ab00.svg";